<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title has-text-weight-normal" v-text="title"></p>
    </header>
    <div class="card-content has-text-weight-normal">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'BasicCard',
    props: {
      title: {
        type: String,
        default: 'Title'
      }
    }
  }
</script>
<style scoped>
  .card {
    box-shadow: none;
    margin-bottom: 30px;
  }

  .card .card-header {
    background-color: #e7e5e5;
    color: #58595b;
  }

  .card .card-content {
    background-color: #f5f5f5;
    color: #565e65;
    font-size: 0.85rem;
  }

  .card .card-content p {
    margin-bottom: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/card/BasicCard.vue